/**
 * Что ассистент говорит, когда протокол готов.
 *
 * Замечание считается ПРАВИЛАМИ по тексту, а не вторым вызовом модели: модель,
 * которой поручено оценить собственный вывод, хвалит его и звучит пусто.
 * Правило же говорит проверяемое — и молчит, когда сказать нечего.
 *
 * 🔴 Ошибиться здесь дороже, чем промолчать: замечание «нет сроков» под
 * протоколом, где сроки есть, разом обесценивает и совет поделиться. Поэтому
 * каждое правило срабатывает только при ЯВНОМ отсутствии признака.
 */

// Дата, день недели, «до 15-го», «на следующей неделе», прямое слово «срок».
const DEADLINE = new RegExp(
  '(\\d{1,2}[./]\\d{1,2}'
  + '|\\d{1,2}\\s*(январ|феврал|март|апрел|ма[йя]|июн|июл|август|сентябр|октябр|ноябр|декабр)'
  + '|до\\s+\\d|к\\s+\\d'
  + '|(понедельник|вторник|сред[ае]|четверг|пятниц[ауеы]|суббот|воскресень)'
  + '|на следующей неделе|в течение\\s+\\d'
  + '|срок|дедлайн|дедлайны)', 'i');

// «Ответственный», поручение — или просто человек, названный по имени.
const OWNER = new RegExp(
  '(ответственн|исполнител|поручен|закреплен'
  + '|[А-ЯЁ][а-яё]{2,}\\s+[А-ЯЁ][а-яё]{2,}'          // Иван Петров
  + '|[А-ЯЁ][а-яё]{2,}\\s+[А-ЯЁ]\\.\\s?[А-ЯЁ]\\.)');  // Петров И. О.

/**
 * Одно замечание к протоколу — или null, если сказать нечего.
 *
 * Ровно одно: два замечания подряд читаются как придирка, а не как помощь.
 */
export function protocolHint(protocolText, transcriptText = '') {
  const text = (protocolText || '').trim();
  if (!text) return null;

  if (!DEADLINE.test(text)) return 'сроков в нём нет';
  if (!OWNER.test(text)) return 'ответственные не названы';
  // Пересказ в двадцать раз короче исходника — обычно потеряны детали.
  const transcript = (transcriptText || '').trim();
  if (transcript.length > 4000 && text.length * 20 < transcript.length) {
    return 'он заметно короче встречи — возможно, стоит попросить подробнее';
  }
  return null;
}

/**
 * Реплика ассистента о готовом протоколе.
 *
 * Одно наблюдение и одно предложение — как в приветствии чата. Предложение
 * поделиться идёт последним, потому что это и есть действие, к которому мы
 * подталкиваем: функцией пользуются единицы просто потому, что о ней не знают.
 */
export function protocolReadyMessage({ protocolText, transcriptText, canShare }) {
  if (!(protocolText || '').trim()) return null;
  const hint = protocolHint(protocolText, transcriptText);
  const parts = ['Протокол готов.'];
  if (hint) parts.push(`Обратите внимание: ${hint}.`);
  if (canShare) {
    parts.push('Могу дать ссылку — отправьте её участникам встречи, '
               + 'открывается без входа в Newton.');
  }
  return parts.join(' ');
}
